import { render, staticRenderFns } from "./VlPreviousExaminations.vue?vue&type=template&id=1c80ed85&scoped=true&"
import script from "./VlPreviousExaminations.vue?vue&type=script&lang=js&"
export * from "./VlPreviousExaminations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c80ed85",
  null
  
)

export default component.exports